import { useState } from 'react';
import { icn_call, icn_location } from '../../imports.js';
import { PrivacyPolicies } from '../pages.js';
import './ContactPage.css'
import { toast } from 'sonner';

const ContactPage = () => {
    const [showPrivacyPolicy, setShowPrivacyPolicy] = useState(false);
    const [privacyAccepted, setPrivacyAccepted] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        message: '',
    });

    const handlePrivacyPolicyClick = (e) => {
        e.preventDefault();
        setShowPrivacyPolicy(true);
    };

    const handlePrivacyAccept = () => {
        setPrivacyAccepted(true);
        setShowPrivacyPolicy(false);
    };

    const handlePrivacyDecline = () => {
        setShowPrivacyPolicy(false);
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ 
            ...prev, 
            [name]: value 
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!privacyAccepted) {
            toast.error('Please review and accept our privacy policy before submitting the form.');
        }

        setIsSubmitting(true);

        try {
            const response = await fetch(
                `${process.env.REACT_APP_SUPABASE_FUNCTION_URL}/send-contact-us-email`,
                {
                    method: 'POST',
                    headers: {
                        'Content-Type': 'application/json',
                    },
                    body: JSON.stringify(formData),
                }
            );

            const data = await response.json();

            if (!response.ok) {
                throw new Error(data.error || 'Failed to send message');
            }
            toast.success('Message sent successfully');
            setFormData({
                firstName: '',
                lastName: '',
                email: '',
                phone: '',
                message: '',
            });
        } catch (error) {
            console.error('Error sending message:', error);
            toast.error('Failed to send message. Please try again later.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div className='contact-page-container'>
            {showPrivacyPolicy && <PrivacyPolicies onAgree={handlePrivacyAccept} onDecline={handlePrivacyDecline} />}
            <div className='contact-page-text-container'>
                <div className="contact-options">
                    <div className="contact-option">
                        <div className="icon-container">
                            <img src={icn_location} alt='location' />
                        </div>
                        <p className='contact-pre-header'>Visit us</p>
                        <p>Our Fargo shop</p>
                        <a href="https://www.google.com/maps?q=1327+3rd+Ave+N,+Fargo,+ND+58102" target="_blank" rel="noopener noreferrer">View on Google Maps</a>
                    </div>
                    <div className="contact-option">
                        <div className="icon-container">
                            <img src={icn_call} alt='contact' />
                        </div>
                        <p className='contact-pre-header'>Call us</p>
                        <p>Mon-Fri | 8:00am - 7:30pm</p>
                        <p>Sat &emsp; &ensp; | 8:30am - 7:30pm</p>
                        <p>Sun &emsp; &ensp;| 1pm - 7:30pm</p>
                        <a href="tel:+17018936853">+1 (701) 893-6853</a>
                    </div>
                </div>
            </div>
            <div className='contact-page-form-container'>
                <div className="contact-page-form-header-container">
                    <h1 className="contact-form-header">Get in touch</h1>
                    <p className="contact-form-sub-header">Our friendly team would love to hear from you</p>
                </div>
                <form className='contact-form' onSubmit={handleSubmit}>
                    <div className="form-group horizontal-group">
                        <input
                            type="text"
                            name="firstName"
                            placeholder="First name"
                            value={formData.firstName}
                            onChange={handleInputChange}
                            required
                        />
                        <input
                            type="text"
                            name="lastName"
                            placeholder="Last name"
                            value={formData.lastName}
                            onChange={handleInputChange}
                            required
                        />
                    </div>
                    <div className="form-group horizontal-group">
                        <input
                            type="email"
                            name="email"
                            placeholder="Email address"
                            value={formData.email}
                            onChange={handleInputChange}
                            required
                        />
                        <input
                            type="phone"
                            name="phone"
                            placeholder="Phone number"
                            value={formData.phone}
                            onChange={handleInputChange}
                            required
                        />
                    </div>
                    <div className="form-group">
                        <textarea
                            name="message"
                            placeholder="Leave us a message..."
                            value={formData.message}
                            onChange={handleInputChange}
                            required
                        >
                        </textarea>
                    </div>
                    <div className="form-group checkbox-group">
                        <input 
                            type="checkbox" 
                            name="privacyPolicy" 
                            id="privacyPolicy" 
                            checked={privacyAccepted} 
                            onChange={() => setPrivacyAccepted(!privacyAccepted)}
                            readOnly 
                            required 
                        />
                        <label htmlFor="privacyPolicy">You agree to our friendly <a href="/privacy-policy" onClick={handlePrivacyPolicyClick}>privacy policy</a>.</label>
                    </div>
                    <button 
                        type="submit" 
                        className="submit-button"
                        disabled={isSubmitting}
                    >
                        {isSubmitting ? 'Sending...' : 'Send Message'}
                    </button>
                </form>
            </div>
        </div>
    )
};

export default ContactPage;